import apiurl from './apiurl';
import axios from 'axios';

const authHeaders = (idToken) => ({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + idToken
});

// GET del rango: 200 = resultado (precalculado/mixto), 202 = requiere job asíncrono
const checkDocumentosCargadosDesdeHasta = async (idToken, params) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'checkDocumentosCargadosDesdeHasta',
            headers: authHeaders(idToken),
            params
        });
    } catch (error) {
        console.error('Error en la llamada a la API:', error);
        throw error;
    }
};

// POST crea el job asíncrono que precalcula los días del rango. Responde {jobId}.
export const crearJobCheckDocs = async (idToken, data) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'checkDocumentosCargadosDesdeHasta/jobs',
            headers: authHeaders(idToken),
            data
        });
    } catch (error) {
        console.error('Error al crear el job:', error);
        throw error;
    }
};

// GET del estado del job: {status: pending|running|done|error, diasCompletados, diasTotales, ...}
export const getJobCheckDocs = async (idToken, jobId) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'checkDocumentosCargadosDesdeHasta/jobs/' + jobId,
            headers: authHeaders(idToken)
        });
    } catch (error) {
        console.error('Error al consultar el job:', error);
        throw error;
    }
};

export default checkDocumentosCargadosDesdeHasta;
